import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";

export function CheckpointCard({
  data,
  onSendMessage,
  disabled,
}: {
  data: any;
  onSendMessage?: (msg: string) => void;
  disabled?: boolean;
}) {
  const [feedback, setFeedback] = useState("");
  const [acted, setActed] = useState(false);
  const toolCount = data.tools_called || 0;

  const handleAction = (msg: string) => {
    if (disabled) return;
    onSendMessage?.(msg);
    setActed(true);
  };

  if (acted) return null;

  return (
    <div className="py-1.5">
      <div
        className={cn(
          "p-3 rounded-xl animate-in fade-in border max-w-[85%]",
          "border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-950/30",
        )}
      >
        <p className="text-xs font-bold mb-2 uppercase tracking-tight flex items-center gap-1.5 text-blue-700 dark:text-blue-300">
          <ShieldCheck className="h-3.5 w-3.5" />
          Progress Checkpoint
        </p>
        <p className="text-sm mb-2">
          I&apos;ve been researching your question
          {toolCount > 0
            ? ` and checked ${toolCount} source${toolCount !== 1 ? "s" : ""}`
            : ""}
          . How should I proceed?
        </p>
        <div className="flex flex-wrap gap-2 mb-2">
          <button
            type="button"
            onClick={() => handleAction("continue")}
            disabled={disabled}
            className="px-3 py-1.5 text-xs font-medium rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Keep going
          </button>
          <button
            type="button"
            onClick={() => handleAction("give me the answer with what you have")}
            disabled={disabled}
            className="px-3 py-1.5 text-xs font-medium rounded-md border border-border bg-background hover:bg-muted transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Answer now
          </button>
        </div>
        <div className="flex items-center gap-2">
          <input
            type="text"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && feedback.trim())
                handleAction(feedback.trim());
            }}
            placeholder="Or redirect: e.g. 'focus on the trigger instead'"
            disabled={disabled}
            className="flex-1 px-3 py-1.5 text-xs rounded-md border border-border bg-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:opacity-50"
          />
          <button
            type="button"
            onClick={() => {
              if (feedback.trim()) handleAction(feedback.trim());
            }}
            disabled={disabled || !feedback.trim()}
            className="px-3 py-1.5 text-xs font-medium rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
}
